export const UPDATE_VALUE = 'fulcrum/containers/Form/PcieSwitchRetimer/UPDATE_VALUE'
export const ADD_VALUE = 'fulcrum/containers/Form/PcieSwitchRetimer/ADD_VALUE'
export const REMOVE_VALUE = 'fulcrum/containers/Form/PcieSwitchRetimer/DELETE_VALUE'
